import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Space,
  Table,
  Switch,
  Form,
  Input,
  Modal,
  Col,
  Row,
  message,
  Upload,
} from "antd";
import imageCompression from "browser-image-compression";
import { useDebouncedCallback } from "use-debounce";
import ImgCrop from "antd-img-crop";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Layout from "../../../components/Layout";
import {
  ReloadOutlined,
  PlusOutlined,
  WarningOutlined,
  SearchOutlined,
  MailOutlined,
  LinkOutlined,
  DownloadOutlined,
  // WarningOutlined,
  EditOutlined,
} from "@ant-design/icons";
import {
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiTwitterFill,
  RiYoutubeFill,
} from "react-icons/ri";
import { COLORS } from "../../../config/theme";
import { API, Domain, request } from "../../../config/API";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import authHeader from "../../../redux/services/authHeader";
import { formatDistanceToNow } from "date-fns";
import ROLES, { EDITOR_ADMIN, VIWEER_ADMIN } from "../../../config/roles";
import { profileImgPlaceholder } from "../../../assets/images";
import { FiExternalLink } from "react-icons/fi";
import { updateTourState } from "../../../redux/actions/Admin/admin.actions";
import QRCode from "../../../components/QRCode";
import { useCallback } from "react";
import AddWalletButton from "../../../components/AddWalletButton";
import MassEditModal from "./MassEditModal";
import LocationSearch from "../../../components/LocationSearch";
const iconNames = require("../../../helpers/ICONS.json");

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};
const MyQr = () => {
  const {
    user: { role },
  } = useSelector((state) => state.auth);

  const { subscribedPlan } = useSelector((state) => state.membership);
  const { tourActive } = useSelector((state) => state.user);
  const history = useHistory();
  const [myQr, setMyQr] = useState([]);
  const [count, setCount] = useState(null);
  const [remaining, setRemaining] = useState(null);
  const [soloInvite, setSoloInvite] = useState("");
  const [inviteAllModal, setInviteAllModal] = useState(false);
  const [quickEditCard, setQuickEditCard] = useState({}); // to select the card and show the quick edit modal
  const [showMassEditModal, setShowMassEditModal] = useState(false);

  const [massInvite, setMassInvite] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { primaryDark, white, lightGray } = COLORS;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [form1] = Form.useForm();
  const formRef1 = useRef(null);
  const { Item } = Form;
  const { Search } = Input;

  const controller = new AbortController();
  ///////////////////////////// Quick Edit \\\\\\\\\\\\\\\\\\\\\\\\\\\
  const [locationInfo, setLocationInfo] = useState({});
  const [isEditting, setIsEditing] = useState(false);
  const [isFacebook, setIsFacebook] = useState(false);
  const [isInstagram, setIsInstagram] = useState(false);
  const [isLinkedin, setIsLinkedin] = useState(false);
  const [isTwitter, setIsTwitter] = useState(false);
  const [isYoutube, setIsYoutube] = useState(false);
  const [iconModal, setIconModal] = useState("");
  const [websites, setWebsites] = useState([]);
  const [searchIconValue, setSearchIconValue] = useState("");
  const [searchedIcon, setSearchIcons] = useState([]);
  const handleQuickEdit = (e) => {
    setQuickEditCard({ ...quickEditCard, [e.target.name]: e.target.value });
  };
  const setFormSocialLinks = useCallback(
    () => (fieldName, value) => {
      form1.setFieldsValue({ [fieldName]: value });
    },
    [form1]
  );
  useEffect(() => {
    if (Object.keys(quickEditCard).length > 0) {
      quickEditCard.socialLinks.forEach(({ name, link, id }) => {
        if (name === "facebook" && link) {
          setIsFacebook(true);
          setFormSocialLinks("facebook", link);
        }
        if (name === "instagram" && link) {
          setIsInstagram(true);
          setFormSocialLinks("instagram", link);
        }
        if (name === "linkedin" && link) {
          setIsLinkedin(true);
          setFormSocialLinks("linkedin", link);
        }
        if (name === "twitter" && link) {
          setIsTwitter(true);
          setFormSocialLinks("twitter", link);
        }
        if (name === "youtube" && link) {
          setIsYoutube(true);
          setFormSocialLinks("youtube", link);
        }
      });
    }
  }, [quickEditCard, setFormSocialLinks]);
  const onWebsiteValueChange = (e, _id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < existingWebsites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          [e.target.name]:
            e.target.name === "link"
              ? e.target.value.replace("https://", "")
              : e.target.value,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleCloseQuickEditModal = () => {
    setQuickEditCard({});
    setIsFacebook(false);
    setIsInstagram(false);
    setIsTwitter(false);
    setIsLinkedin(false);
    setIsYoutube(false);
    form1.resetFields();
  };
  const EditQr = () => {
    const socialLinks = [
      {
        name: "facebook",
        link: form1?.getFieldValue("facebook")
          ? form1?.getFieldValue("facebook")?.includes("facebook.com")
            ? form1.getFieldValue("facebook")
            : "facebook.com/" + form1.getFieldValue("facebook")
          : "",
      },
      {
        name: "instagram",
        link: form1?.getFieldValue("instagram")
          ? form1?.getFieldValue("instagram")?.includes("instagram.com")
            ? form1.getFieldValue("instagram")
            : "instagram.com/" + form1.getFieldValue("instagram")
          : "",
      },
      {
        name: "linkedin",
        link: form1?.getFieldValue("linkedin")
          ? form1?.getFieldValue("linkedin")?.includes("linkedin.com")
            ? form1.getFieldValue("linkedin")
            : "linkedin.com/" + form1.getFieldValue("linkedin")
          : "",
      },
      {
        name: "twitter",
        link: form1?.getFieldValue("twitter")
          ? form1?.getFieldValue("twitter")?.includes("twitter.com")
            ? form1?.getFieldValue("twitter")
            : "twitter.com/" + form1?.getFieldValue("twitter")
          : "",
      },
      {
        name: "skype",
        link: form1?.getFieldValue("skype")
          ? form1?.getFieldValue("skype")?.includes("skype.com")
            ? form1?.getFieldValue("skype")
            : "skype.com/" + form1?.getFieldValue("skype")
          : "",
      },
      {
        name: "behance",
        link: form1?.getFieldValue("behance")
          ? form1?.getFieldValue("behance")?.includes("behance.com")
            ? form1?.getFieldValue("behance")
            : "behance.com/" + form1?.getFieldValue("behance")
          : "",
      },
      {
        name: "youtube",
        link: form1?.getFieldValue("youtube")
          ? form1?.getFieldValue("youtube")?.includes("youtube.com")
            ? form1?.getFieldValue("youtube")
            : "youtube.com/" + form1?.getFieldValue("youtube")
          : "",
      },
      {
        name: "whatsapp",
        link: form1?.getFieldValue("whatsapp")
          ? form1?.getFieldValue("whatsapp")?.includes("wa.me")
            ? form1?.getFieldValue("whatsapp")
            : "wa.me/" + form1?.getFieldValue("whatsapp")
          : "",
      },
      {
        name: "maps",
        link: form1?.getFieldValue("maps")
          ? form1?.getFieldValue("maps")?.includes("goo.gl/maps")
            ? form1?.getFieldValue("maps")
            : "goo.gl/maps/" + form1?.getFieldValue("maps")
          : "",
      },
      { name: "mail", link: form1?.getFieldValue("mail") },
      {
        name: "telegram",
        link: form1?.getFieldValue("telegram")
          ? form1?.getFieldValue("telegram")?.includes("t.me")
            ? form1?.getFieldValue("telegram")
            : "t.me/" + form1?.getFieldValue("telegram")
          : "",
      },
      {
        name: "tiktok",
        link: form1?.getFieldValue("tiktok")
          ? form1?.getFieldValue("tiktok")?.includes("vt.tiktok.com")
            ? form1?.getFieldValue("tiktok")
            : "vt.tiktok.com/" + form1?.getFieldValue("tiktok")
          : "",
      },
      {
        name: "snapchat",
        link: form1?.getFieldValue("snapchat")
          ? form1?.getFieldValue("snapchat")?.includes("snapchat.com/add")
            ? form1?.getFieldValue("snapchat")
            : "snapchat.com/add/" + form1?.getFieldValue("snapchat")
          : "",
      },
    ];
    setIsEditing(true);
    request
      .put(API + "/qr/quickUpdate/" + quickEditCard?._id, {
        ...quickEditCard,
        locationInfo,
        webLinks: websites,
        socialLinks,
      })
      .then((data) => {
        setIsEditing(false);
        message.success("QR Updated");
        handleCloseQuickEditModal();
        onRefresh();
      })
      .catch((err) => {
        openNotification({
          message: "Error",
          description: err?.response?.data?.data,
          icon: "error",
        });
        setIsEditing(false);
      });
  };
  ////////////////////////////////////////// Custom Icon \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  const handleRemoveIcon = (_id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddCustomIcon = ({ file, onSuccess, onError }, _id) => {
    const options = {
      signal: controller.signal,
      maxSizeMB: 0.05,
    };

    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("customIcon", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const existingWebsites = [...websites];
            for (let index = 0; index < websites.length; index++) {
              if (_id === existingWebsites[index]?._id) {
                const toChangeWebsite = { ...existingWebsites[index] };
                const tempWebsite = {
                  ...toChangeWebsite,
                  image: data.customIcon,
                };
                existingWebsites[index] = tempWebsite;
              }
            }
            setIconModal("");
            setWebsites(existingWebsites);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
  };
  const handleImageRemove = (image, key) => {
    request
      .put(
        `qr/image/${quickEditCard._id}`,
        { [key]: image },
        { headers: { ...authHeader() } }
      )
      .then(() => {})
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
      });
  };
  const handleRemoveCustomIcon = (image, _id) => {
    request
      .put("qr/image", { image }, { headers: { ...authHeader() } })
      .then(() => {})
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
      });
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          image: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddIcon = (_id, icon) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: icon,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setIconModal("");
    setWebsites(existingWebsites);
  };
  const handleSearchIcon = () => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    const searchedIcon = iconNames.filter((item) => {
      return item.match(searchIconValue.toLowerCase());
    });
    if (searchedIcon.length > 0) {
      setSearchIcons(searchedIcon);
    } else {
      setSearchIcons([]);
    }
  };
  const debounced = useDebouncedCallback(() => {
    handleSearchIcon();
  }, 500);
  useEffect(() => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    debounced(searchIconValue);
  }, [debounced, searchIconValue]);
  //////////////////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  const handleMassDownloadQR = () => {
    const massInviteLinks = massInvite.map((e) => e.link);

    massInviteLinks.forEach((link) => {
      const canvas = document.getElementsByClassName(`${link}`)[0].firstChild;
      const pngUrl = canvas
        ?.toDataURL("image/png")
        ?.replace("image/png", "image/octet-stream");
      let downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = link + ".png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };

  ///////////////////////////// pagination \\\\\\\\\\\\\\\\\\\\\\\\\\\
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setMassInvite(selectedRows);
    },
  };
  const handleInviteSoloStaff = (data) => {
    const newData = { ...data, waveCardId: soloInvite };
    setSoloInvite("");
    setIsLoading(true);
    request
      .post("/qr/inviteSoloStaff", newData, {
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setIsLoading(false);
        form.resetFields();
        onRefresh();
      })
      .catch((err) => {
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  const handleInviteStaff = (data) => {
    setInviteAllModal(false);
    let allEmailsExist = true;
    data.forEach((item) => {
      if (!item.email) {
        allEmailsExist = false;
      }
    });

    if (!allEmailsExist && data.length > 0) {
      openNotification({
        message: "Error",
        description: "Email missing in profile card",
        icon: "error",
      });
      return;
    }
    setIsLoading(true);
    request
      .post("/qr/inviteStaff", data, {
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setIsLoading(false);
        onRefresh();
      })
      .catch((err) => {
        const error = err?.response?.data || "Something Happened";
        openNotification({
          message: "Error",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  const onRefresh = () => {
    setIsLoading(true);
    request
      .get(`/qr/myQr`, {
        params: { pageSize, pageNumber: currentPage },
      })
      .then(({ data: { data } }) => {
        setMyQr(data?.qr);
        setCount(data?.count);
        setRemaining(data?.remaining);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        openNotification({
          message: "Error!",
          description: err,
          icon: "error",
        });
      });
  };

  useEffect(() => {
    onRefresh();
    //eslint-disable-next-line
  }, [dispatch, currentPage, pageSize]);

  //search
  const [searchedData, setSearchedData] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchvalue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("undecided");
  const onSearch = () => {
    if (searchvalue.length < 1) {
      return;
    }
    setIsSearching(true);
    request
      .post(
        "/user/qr/search",
        { query: searchvalue },
        { headers: { ...authHeader() } }
      )
      .then(({ data: { data } }) => {
        setSearchedData(data);
        setIsSearching(false);
        setSearchStatus("success");
      })
      .catch((e) => {
        console.log("🚀 ~ file: QRCodes.jsx ~ line 142 ~ onSearch ~ e", e);
        setIsSearching(false);
        setSearchStatus("error");
      });
  };
  useEffect(() => {
    if (searchvalue.length < 1) {
      setSearchedData([]);
      setSearchStatus("undecided");
    }
  }, [searchvalue]);
  const SearchDebounce = useDebouncedCallback(() => {
    onSearch();
  }, 500);
  useEffect(() => {
    if (!searchvalue) return;
    SearchDebounce(searchvalue);
  }, [SearchDebounce, searchvalue]);

  const columns = [
    {
      width: "10%",
      title: "Profile",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (image) => (
        <img
          draggable={false}
          style={{ aspectRatio: 1, width: "3.5rem", borderRadius: "1.7rem" }}
          src={image ? `${Domain}/data/${image}` : profileImgPlaceholder}
          alt=""
        />
      ),
    },
    {
      width: "10%",
      title: () => <p id="link_title"> Link</p>,
      dataIndex: "link",
      key: "link",
      render: (text) => (
        <Link target="_blank" to={"/wc/" + text}>
          {text}
        </Link>
      ),
    },
    {
      width: "15%",
      title: "Created By",
      dataIndex: ["owner", "fullName"],
      key: "owner",
    },
    {
      width: "15%",
      title: "Wave Name",
      dataIndex: "fName",
      key: "qrName",
      render: (row, entry) => `${row} ${entry?.lName && entry?.lName}`,
    },
    {
      width: "8%",
      title: "Total Scans",
      dataIndex: "count",
      key: "count",
    },
    {
      width: "10%",
      title: "Last Updated/Scanned",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) =>
        formatDistanceToNow(new Date(text), { addSuffix: true }),
    },
    {
      width: "15%",
      title: "Card Owner",
      dataIndex: ["associatedTo", "email"],
      key: "associatedTo",
    },
    {
      width: "15%",
      title: "Invited By",
      dataIndex: ["invitedBy", "fullName"],
      key: "invitedBy",
    },
    {
      width: "10%",
      title: "Export card to wallet app",
      dataIndex: "_id",
      key: "_id",
      render: (text) => {
        return <AddWalletButton vCard={{ _id: text }}></AddWalletButton>;
      },
    },
    {
      width: "10%",
      title: "Assign Card",
      render: (text) => {
        return (
          <>
            <Button
              id="assign_card_button"
              disabled={
                role === VIWEER_ADMIN || role === EDITOR_ADMIN ? true : false
              }
              shape="round"
              type="primary"
              style={{
                background:
                  role === VIWEER_ADMIN || role === EDITOR_ADMIN
                    ? "lightGray"
                    : primaryDark,
                borderColor:
                  role === VIWEER_ADMIN || role === EDITOR_ADMIN
                    ? white
                    : primaryDark,
                color: white,
              }}
              onClick={() => {
                setSoloInvite(text?._id);
              }}
              icon={<MailOutlined />}
            >
              Assign Card
            </Button>
          </>
        );
      },
    },
    {
      width: "10%",
      title: "Contact Exchange",
      key: "lead",
      render: (text) => {
        return (
          <>
            <Switch
              id="contact_exchange_card_button"
              style={{
                background: !text?.leadEnable ? "#FF6461" : "#55B659",
              }}
              disabled={
                role === VIWEER_ADMIN || role === EDITOR_ADMIN
                  ? true
                  : subscribedPlan?.paymentStatus !== "SUCCESS"
              }
              checkedChildren={"ENABLE"}
              unCheckedChildren={"DISABLE"}
              checked={text?.leadEnable}
              onChange={() => {
                const tempMyQr = [...myQr];
                const objIndex = tempMyQr.findIndex(
                  (obj) => obj?._id === text?._id
                );
                const tempObj = {
                  ...tempMyQr[objIndex],
                  leadEnable: !text?.leadEnable,
                };
                tempMyQr[objIndex] = tempObj;
                setMyQr(tempMyQr);
                request
                  .post(
                    `leadgeneration/enableLeadGeneration`,
                    { qrId: text?._id },
                    {
                      headers: { ...authHeader() },
                    }
                  )
                  .then(({ data }) => {
                    onRefresh();
                  })
                  .catch((err) => {
                    onRefresh();
                    console.log("error=>", err);
                    const error =
                      err?.response?.data.data || err?.response?.statusText;
                    openNotification({
                      message: "Error",
                      description: error,
                      icon: "error",
                    });
                  });
              }}
            />
          </>
        );
      },
    },
    {
      width: "10%",
      title: () => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {"Actions"}
        </div>
      ),
      key: "actions",
      render: (text) => {
        return (
          <Space>
            <Switch
              id="block_card_button"
              style={{ background: !text?.block ? "#55B659" : "#FF6461" }}
              checkedChildren={"Blocked"}
              unCheckedChildren={"Active"}
              disabled={
                role === VIWEER_ADMIN || role === EDITOR_ADMIN ? true : false
              }
              checked={text?.block}
              onChange={() => {
                request
                  .put(`qr/block/${text?._id}`, null, {
                    headers: { ...authHeader() },
                  })
                  .then(
                    ({
                      data: {
                        data: { block },
                      },
                    }) => {
                      openNotification({
                        message: "Success",
                        description: block ? "QR Blocked" : "QR Unblocked",
                        icon: "success",
                      });
                      onRefresh();
                    }
                  )
                  .catch((err) => {
                    const error =
                      err?.response?.message || err?.response?.statusText;
                    openNotification({
                      message: "Error",
                      description: error,
                      icon: "error",
                    });
                  });
              }}
            />
            <Button
              id="edit_card_button"
              disabled={role === VIWEER_ADMIN ? true : false}
              shape="round"
              onClick={() =>
                window.open(`edit-wave-card/${text?.link}`, "_blank")
              }
            >
              Edit
            </Button>
            <Button
              disabled={role === VIWEER_ADMIN ? true : false}
              shape="round"
              onClick={() => {
                form1.resetFields();
                setQuickEditCard(text);
                setWebsites(text.webLinks);
              }}
            >
              Quick Edit
            </Button>
            <div>
              <Button
                shape="round"
                onClick={() => {
                  const canvas = document.getElementsByClassName(
                    `${text.link}`
                  )[0].firstChild;
                  const pngUrl = canvas
                    ?.toDataURL("image/png")
                    ?.replace("image/png", "image/octet-stream");
                  let downloadLink = document.createElement("a");
                  downloadLink.href = pngUrl;
                  downloadLink.download = text.link + ".png";
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                }}
              >
                Download Qr
              </Button>
              <div
                className={`qrcode ${text.link}`}
                style={{
                  display: "none",
                }}
              >
                <QRCode
                  size={text?.qrSetting?.size}
                  value={`${
                    process.env.REACT_APP_DOMAIN_URL ||
                    "https://wavecodes.com.au"
                  }/wc/${text?.link}`}
                  quietZone={text?.qrSetting?.quietZone}
                  fgColor={text?.qrSetting?.fgColor}
                  bgColor={text?.qrSetting?.bgColor}
                  ecLevel={text?.qrSetting?.ecLevel}
                  qrStyle={text?.qrSetting?.qrStyle}
                  eyeRadius={text?.qrSetting?.eyeRadius}
                  logoImage={text?.qrSetting?.logoImage}
                  logoWidth={text?.qrSetting?.logoWidth}
                  logoHeight={text?.qrSetting?.logoHeight}
                  logoOpacity={text?.qrSetting?.logoOpacity}
                />
              </div>
            </div>
          </Space>
        );
      },
    },
  ];
  //////////////////////

  ////////////////////
  const tourContinue = useCallback(() => {
    if (tourActive) {
      const tempQr = {
        address: "Your address",
        block: false,
        company: "Your company",
        count: 1,
        createdAt: "2022-11-17T06:14:46.283Z",
        email: "card@email.com",
        fName: "Your",
        lName: "Name",
        leadEnable: false,
        link: "lI3n12k",
        mobile: "0731122***",
        owner: { _id: "123123123", fullName: "ower@email.com" },
        profileImage: null,
        qrSetting: {
          size: "256",
          quietZone: "10",
          ecLevel: "L",
          bgColor: "#FFFFFF",
          fgColor: "#000000",
        },
        socialLinks: [],
        updatedAt: "2022-11-17T09:46:34.718Z",
        webLinks: [],
        _id: "123123123",
      };

      setTimeout(() => {
        if (myQr.length === 0) {
          setMyQr([tempQr]);
        }
        dispatch(updateTourState(true, null, true)); //run, stepIndex, tourActive
      }, 1500);
    }
  }, [dispatch, tourActive, myQr.length]);
  useEffect(() => {
    tourContinue();
  }, [tourContinue]);
  return (
    <Layout heading="My Wave Cards" hasBadge stat={count}>
      <Space style={{ marginBottom: 24, float: "right" }} wrap={true}>
        <Form
          onFinish={() => {
            if (searchvalue === "") {
              alert("Please enter some value!");
            } else {
              onSearch();
            }
          }}
          onFinishFailed={(x) => {
            console.log(x);
          }}
          style={{ display: "flex" }}
        >
          <Form.Item
            name="search"
            // label="Search"
            style={{ margin: 0 }}
          >
            <Input
              style={{ borderTopLeftRadius: 50, borderBottomLeftRadius: 50 }}
              allowClear
              value={searchvalue}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
              placeholder="Search ..."
            />
          </Form.Item>
          <Form.Item style={{ margin: 0 }}>
            <Button
              type="primary"
              style={{
                width: 50,
                background: primaryDark,
                borderTopRightRadius: 50,
                borderBottomRightRadius: 50,
                border: "none",
                paddingLeft: 10,
                paddingRight: 10,
              }}
              htmlType="submit"
              loading={isSearching}
              icon={<SearchOutlined />}
            />
          </Form.Item>
        </Form>

        {role !== VIWEER_ADMIN &&
          role !== EDITOR_ADMIN &&
          massInvite?.length > 1 && (
            <Button
              type="primary"
              shape="round"
              icon={remaining <= 0 ? <WarningOutlined /> : <EditOutlined />}
              disabled={
                remaining <= 0 ||
                ![ROLES.EDITOR_ADMIN, ROLES.ADMIN, ROLES.ACTING_ADMIN].includes(
                  role
                )
              }
              style={{
                background:
                  remaining <= 0 ||
                  ![
                    ROLES.EDITOR_ADMIN,
                    ROLES.ADMIN,
                    ROLES.ACTING_ADMIN,
                  ].includes(role)
                    ? "lightGray"
                    : primaryDark,
                borderColor:
                  remaining <= 0 ||
                  ![
                    ROLES.EDITOR_ADMIN,
                    ROLES.ADMIN,
                    ROLES.ACTING_ADMIN,
                  ].includes(role)
                    ? "lightGray"
                    : primaryDark,
                color: white,
              }}
              onClick={() => setShowMassEditModal(true)}
            >
              {"Mass Edit"}
            </Button>
          )}
        {massInvite?.length > 1 && (
          <Button
            type="primary"
            shape="round"
            icon={<PlusOutlined />}
            disabled={massInvite?.length > 0 ? false : true}
            style={{
              background: massInvite?.length > 0 ? primaryDark : lightGray,
              borderColor: primaryDark,
              color: massInvite?.length > 0 ? white : primaryDark,
            }}
            onClick={() => setInviteAllModal(true)}
          >
            {"Mass Invite"}
            {massInvite?.length > 0 && (
              <div
                style={{
                  display: "flex",
                  position: "absolute",
                  width: "2rem",
                  height: "2rem",
                  backgroundColor: white,
                  borderColor: "red",
                  borderWidth: "1rem",
                  top: "-1.5rem",
                  right: "0rem",
                  borderRadius: "1rem",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p style={{ color: primaryDark }}> {massInvite?.length}</p>
              </div>
            )}
          </Button>
        )}
        <Button
          type="primary"
          shape="round"
          icon={<DownloadOutlined />}
          disabled={massInvite?.length > 0 ? false : true}
          style={{
            background: massInvite?.length > 0 ? primaryDark : lightGray,
            borderColor: primaryDark,
            color: massInvite?.length > 0 ? white : primaryDark,
          }}
          onClick={() => handleMassDownloadQR()}
        >
          {"Mass QR Download"}
          {massInvite?.length > 0 && (
            <div
              style={{
                display: "flex",
                position: "absolute",
                width: "2rem",
                height: "2rem",
                backgroundColor: white,
                borderColor: "red",
                borderWidth: "1rem",
                top: "-1.5rem",
                right: "0rem",
                borderRadius: "1rem",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p style={{ color: primaryDark }}> {massInvite?.length}</p>
            </div>
          )}
        </Button>

        {role !== VIWEER_ADMIN && role !== EDITOR_ADMIN && (
          <Button
            type="primary"
            shape="round"
            icon={
              remaining <= 0 ? <WarningOutlined /> : <PlusOutlined />
              // <PlusOutlined />
            }
            disabled={remaining <= 0}
            style={{
              background: primaryDark,
              borderColor: primaryDark,
              color: white,
            }}
            onClick={() => history.push("/app/create-wave-card")}
          >
            {remaining <= 0 ? "Limit Reached" : "Add Wave Card"}
            {/* {"Add Wave Card"} */}
          </Button>
        )}
        <Button
          shape="round"
          type="primary"
          style={{ background: primaryDark, borderColor: primaryDark }}
          onClick={onRefresh}
          icon={<ReloadOutlined />}
        >
          Refresh
        </Button>
      </Space>

      <Table
        size="large"
        dataSource={
          searchvalue.length > 0 && searchStatus === "success"
            ? searchedData
            : myQr
        }
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        rowKey={({ _id }) => _id}
        columns={columns}
        loading={isLoading}
        pagination={{
          hideOnSinglePage: true,
          pageSize: pageSize,
          current: currentPage,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          // showTotal: (total) => `Total ${total} items`,
          onChange: handlePageChange,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
        }}
      />
      {/* Invite Staff Modal */}
      <Modal
        visible={!!soloInvite}
        title="Invite"
        footer={null}
        onCancel={() => {
          setSoloInvite("");
          form.resetFields();
        }}
      >
        <Form
          {...layout}
          form={form}
          ref={formRef}
          labelAlign="left"
          onFinish={handleInviteSoloStaff}
        >
          <Form.Item
            label="Enter Full Name"
            name="fullName"
            hasFeedback
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            hasFeedback
            rules={[
              { required: true, message: "This field is required" },
              { type: "email", message: "Please Enter Valid Email" },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                alignSelf: "center",
                paddingLeft: "4rem",
                paddingRight: "4rem",
              }}
              size="large"
              htmlType="submit"
            >
              Invite
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      {/* Invite Staff Modal */}
      <Modal
        visible={inviteAllModal}
        title="Invite All Conformation"
        footer={null}
        onCancel={() => {
          setInviteAllModal(false);
        }}
      >
        <Col>
          <Row>
            <p>
              All selected users will receive an invitation. The email entered
              in each profile will be used, Please confirm
            </p>
          </Row>
          <Row
            style={{
              marginTop: "2rem",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                width: "8rem",
                justifyContent: "center",
              }}
              size="large"
              onClick={() => handleInviteStaff(massInvite)}
            >
              SEND
            </Button>
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                justifyContent: "center",

                width: "8rem",
              }}
              size="large"
              onClick={() => setInviteAllModal(false)}
            >
              Cancel
            </Button>
          </Row>
        </Col>
      </Modal>
      {/* Quick Edit Modal */}
      <Modal
        visible={Object.keys(quickEditCard).length > 0 ? true : false}
        title="Quick Edit"
        footer={null}
        onCancel={handleCloseQuickEditModal}
      >
        <Col>
          <Form
            name="quickEdit"
            form={form1}
            ref={formRef1}
            onFinishFailed={(err) => console.error(err)}
          >
            {/* First Name */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="First Name"
              hasFeedback
              initialValue={quickEditCard.fName}
              rules={[{ required: true, message: "This field is required" }]}
            >
              <Input
                size="large"
                name="fName"
                value={quickEditCard.fName}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="First Name"
              />
            </Item>
            {/* Last Name */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Last Name"
              hasFeedback
              initialValue={quickEditCard.lName}
            >
              <Input
                size="large"
                name="lName"
                value={quickEditCard.lName}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Last Name"
              />
            </Item>
            {/* Phone no */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Phone no"
              hasFeedback
              initialValue={quickEditCard.phone}
            >
              <Input
                size="large"
                name="phone"
                value={quickEditCard.phone}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Phone no"
              />
            </Item>
            {/* Mobile no */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Mobile no"
              hasFeedback
              initialValue={quickEditCard.mobile}
            >
              <Input
                size="large"
                name="mobile"
                value={quickEditCard.mobile}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Mobile no"
              />
            </Item>
            {/* email */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Email"
              hasFeedback
              initialValue={quickEditCard.email}
            >
              <Input
                size="large"
                name="email"
                value={quickEditCard.email}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Email"
              />
            </Item>
            {/* Job title */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Job title"
              hasFeedback
              initialValue={quickEditCard.jobTitle}
            >
              <Input
                size="large"
                name="jobTitle"
                value={quickEditCard.jobTitle}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Job title"
              />
            </Item>
            {/* Company */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Company"
              hasFeedback
              initialValue={quickEditCard.company}
            >
              <Input
                size="large"
                name="company"
                value={quickEditCard.company}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Company"
              />
            </Item>
            {/* Address */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Address"
              hasFeedback
              initialValue={quickEditCard.address}
            >
              <LocationSearch
                placeholder="Your Address"
                value={quickEditCard.address}
                onChange={handleQuickEdit}
                name="address"
                setLocationInfo={setLocationInfo}
              />
            </Item>
            {/* first web link */}
            {websites.length > 0 && (
              <Row>
                <Item
                  labelCol={{ span: 7 }}
                  labelAlign="left"
                  label="Web Link"
                  hasFeedback
                  initialValue={quickEditCard.company}
                >
                  <div style={{ marginBottom: "1rem" }}>
                    {websites.map((website, index) => {
                      return (
                        <Space
                          key={index}
                          wrap={true}
                          style={{ marginBottom: "1rem" }}
                        >
                          {website?.icon ? (
                            <i
                              onClick={() => {
                                handleRemoveIcon(website._id);
                              }}
                              className={`fas fa-${website?.icon} fa-2x`}
                              style={{
                                margin: "1rem",
                                cursor: "pointer",
                              }}
                            />
                          ) : website?.image ? (
                            <img
                              onClick={() => {
                                handleRemoveCustomIcon(
                                  website.image,
                                  website._id
                                );
                              }}
                              src={Domain + "/data/" + website.image}
                              style={{
                                width: "2rem",
                                height: "2rem",
                                cursor: "pointer",
                                margin: "1rem",
                              }}
                              alt="icon"
                            />
                          ) : (
                            <Button
                              size="large"
                              onClick={() => setIconModal(website._id)}
                              style={{ borderRadius: 8 }}
                            >
                              Icon
                            </Button>
                          )}

                          <Input
                            name="name"
                            style={{ borderRadius: 8 }}
                            placeholder="Link"
                            size="large"
                            value={website.name}
                            onChange={(e) =>
                              onWebsiteValueChange(e, website._id)
                            }
                          />

                          <Input
                            name="link"
                            style={{ borderRadius: 8 }}
                            size="large"
                            value={website.link}
                            placeholder="www.mywebsiteurl.com"
                            prefix={
                              <>
                                <LinkOutlined style={{ paddingRight: 5 }} />
                                {"https://"}
                              </>
                            }
                            onChange={(e) =>
                              onWebsiteValueChange(e, website._id)
                            }
                          />

                          {/* <Button
                            size="large"
                            danger
                            onClick={() => {
                              // handleremoveWebLink(website._id);
                            }}
                            style={{ borderRadius: 8 }}
                            icon={
                              <DeleteOutlined
                                className="linkDeleteIcon"
                                style={{ fontSize: 18 }}
                              />
                            }
                          >
                            Remove
                          </Button> */}
                        </Space>
                      );
                    })}
                  </div>
                </Item>
              </Row>
            )}
            <Row xs={12} md={24} align="center" style={{ gap: 15 }}>
              {/* Facebook */}
              <div
                onClick={() => setIsFacebook(!isFacebook)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isFacebook ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiFacebookBoxFill
                  color={isFacebook ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
              {/* Instagram */}
              <div
                onClick={() => setIsInstagram(!isInstagram)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${
                    isInstagram ? primaryDark : "lightgray"
                  }`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiInstagramFill
                  color={isInstagram ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
              {/* linkedin */}
              <div
                onClick={() => setIsLinkedin(!isLinkedin)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isLinkedin ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiLinkedinBoxFill
                  color={isLinkedin ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
              {/* Twitter */}
              <div
                onClick={() => setIsTwitter(!isTwitter)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isTwitter ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiTwitterFill
                  color={isTwitter ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>

              {/* Youtube */}
              <div
                onClick={() => setIsYoutube(!isYoutube)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isYoutube ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiYoutubeFill
                  color={isYoutube ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
            </Row>
            <Row justify="center" style={{ marginTop: "1rem" }}>
              {isFacebook && (
                <Item
                  name="facebook"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="facebook"
                    style={{
                      borderRadius: 8,
                      width: "25rem",
                    }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("facebook");
                          let link = linkValue.includes("facebook.com")
                            ? linkValue
                            : "facebook.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiFacebookBoxFill
                          color="lightgray"
                          style={{
                            fontSize: 30,
                            marginRight: 10,
                          }}
                        />
                        {!form1.getFieldValue("facebook") && "facebook.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isInstagram && (
                <Item
                  name="instagram"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="instagram"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("instagram");
                          let link = linkValue.includes("instagram.com")
                            ? linkValue
                            : "instagram.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiInstagramFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("instagram") && "instagram.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isLinkedin && (
                <Item
                  name="linkedin"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="linkedin"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("linkedin");
                          let link = linkValue.includes("linkedin.com")
                            ? linkValue
                            : "linkedin.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiLinkedinBoxFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("linkedin") && "linkedin.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isTwitter && (
                <Item
                  name="twitter"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="twitter"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("twitter");
                          let link = linkValue.includes("twitter.com")
                            ? linkValue
                            : "twitter.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiTwitterFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("twitter") && "twitter.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isYoutube && (
                <Item
                  name="youtube"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="youtube"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("youtube");
                          let link = linkValue.includes("youtube.com")
                            ? linkValue
                            : "youtube.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiYoutubeFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("youtube") && "youtube.com/"}
                      </>
                    }
                  />
                </Item>
              )}
            </Row>
          </Form>
          <Row
            style={{
              marginTop: "2rem",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              isLoading={isEditting}
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                width: "8rem",
                justifyContent: "center",
              }}
              size="large"
              onClick={EditQr}
            >
              Save
            </Button>
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                justifyContent: "center",

                width: "8rem",
              }}
              size="large"
              onClick={handleCloseQuickEditModal}
            >
              Cancel
            </Button>
          </Row>
        </Col>
      </Modal>
      {/* Choose Icon */}
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ paddingLeft: "2rem", paddingRight: "2rem" }}
        visible={!!iconModal}
        title="Choose Weblink Icon"
        footer={null}
        onCancel={() => setIconModal("")}
      >
        <Search
          placeholder="Search Icon"
          onSearch={() => {
            handleSearchIcon();
          }}
          value={searchIconValue}
          onChange={(e) => {
            setSearchIconValue(e.target.value);
          }}
          enterButton
        />
        <div style={{ marginTop: "1rem", padding: "1rem" }}>
          {searchedIcon?.length > 0 ? (
            <Space wrap={true}>
              {searchedIcon?.slice(0, 20).map((icon) => (
                <i
                  onClick={() => {
                    handleAddIcon(iconModal, icon);
                  }}
                  key={icon}
                  className={`fas fa-${icon} fa-2x`}
                  style={{ margin: "1rem", cursor: "pointer" }}
                />
              ))}
            </Space>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <p>
                {searchIconValue.length > 0 ? "No Icon Found" : "Search Icon"}
              </p>

              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginTop: ".5rem",
                  marginBottom: ".5rem",
                }}
              >
                OR
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <p>Upload Custom Icon</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <ImgCrop
                    rotate
                    modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                    quality={1}
                    shape="rect"
                    // minZoom={1}
                    // maxZoom={10}
                    // aspect={2 / 1}
                    // modalWidth={530}
                    fillColor="#00000000"
                  >
                    <Upload
                      className="fileList-upload-images"
                      maxCount={1}
                      customRequest={(e) => {
                        handleAddCustomIcon(e, iconModal);
                      }}
                      fileList={[]}
                      listType="picture-card"
                      onRemove={(e) => handleImageRemove(e?.name)}
                      onChange={(e) => {}}
                      accept="image/png"
                    >
                      <PlusOutlined />
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
      {/* Mass Edit Modal */}
      <MassEditModal
        setShowMassEditModal={setShowMassEditModal}
        showMassEditModal={showMassEditModal}
        massData={massInvite}
      ></MassEditModal>
    </Layout>
  );
};

export default MyQr;
